import { ThemedText } from '@/components/themed-text';
import { ServiceOccurrence } from '@/types/service-ocurrency';
import { formatDate, formatTime } from '@/utils/format-date';
import { router } from 'expo-router';
import React from 'react';
import { Pressable, View } from 'react-native';

type OccurrenceCardProps = {
  occurrence: ServiceOccurrence;
};

export function OccurrenceCard({ occurrence }: OccurrenceCardProps) {
  const handlePress = () => {
    if (!occurrence.enrollmentId) {
      console.warn('Enrollment ID is missing, cannot navigate');
      return;
    }
    router.push(`/(tabs)/(provider)/enrollments/${occurrence.enrollmentId}`);
  };

  const timeString = occurrence.startTime
    ? `${formatTime(occurrence.startTime)} ${occurrence.endTime ? `- ${formatTime(occurrence.endTime)}` : ''}`
    : 'Dia todo';

  return (
    <Pressable onPress={handlePress} className="mb-3">
      <View className="w-full rounded-lg border border-border bg-card p-3 shadow-sm">
        <View className="mb-1 flex-row items-center justify-between">
          <ThemedText className="font-semibold text-card-foreground">
            {formatDate(occurrence.date, 'dd/MM/yyyy (EEE)')}
          </ThemedText>
          <ThemedText className="text-xs text-muted-foreground">{timeString}</ThemedText>
        </View>
        <ThemedText className="text-sm text-foreground">
          Cliente:{' '}
          <ThemedText className="font-semibold text-sm text-primary">
            {occurrence.clientName}
          </ThemedText>
        </ThemedText>
      </View>
    </Pressable>
  );
}
